<template>
  <div class="fake-images" :class="{ scrolled: $store.state.page.scrolled }">
    <div class="fake-images__images">
      <div
        class="fake-images__image-wrapper fake-images__image-wrapper--left"
        data-in-out
        data-in-out-animation="rail-left"
        data-in-delay="0.2"
      >
        <div
          class="fake-images__image fake-images__image--left"
          :style="{ backgroundImage: `url('${imageOne}')` }"
        ></div>
      </div>
      <div
        class="fake-images__image-wrapper fake-images__image-wrapper--right"
        data-in-out
        data-in-out-animation="rail-right"
        data-in-delay="0.3"
      >
        <div
          class="fake-images__image fake-images__image--right"
          :style="{ backgroundImage: `url('${imageTwo}')` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FakeImages',

  props: ['imageOne', 'imageTwo'],
};
</script>

<style lang="scss" scoped>
.fake-images {
  @include mq($until: ipadL) {
    display: none;
  }

  &__images {
    position: absolute;
    width: 100vw;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    top: 0px;
    left: 0px;
    pointer-events: none;
  }

  &__image-wrapper {
    position: absolute;

    &--left {
      left: calc((100vw / 32) * 7);
      bottom: 0px;
    }

    &--right {
      right: calc((100vw / 32) * 4);
      top: 0px;
    }
  }

  &__image {
    width: calc((100vw / 32) * 9);
    height: calc((100vw / 32) * 8);
    background-position: center center;
    background-size: cover;
    transition: opacity .6s $inOutCubic,
                transform .6s $inOutCubic;
  }

  &.scrolled {
    .fake-images__image {
      opacity: 0;

      &--left {
        transform: translateY(80px);
      }

      &--right {
        transform: translateY(-80px);
      }
    }
  }
}
</style>
